import React, { createContext, useContext, useState, useEffect } from 'react';
import {SERVER_URL} from '../constants.js';

const CategoryContext = createContext();

export const CategoryContextProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${SERVER_URL}/api/v1/category`); // Adjust endpoint as needed
        const result = await response.json();
        setCategories(result.data || []);
        setLoading(false);
      } catch (err) {
      
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return (
    <CategoryContext.Provider value={{ categories, loading, error }}>
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategoryContext = () => useContext(CategoryContext);